import { type ConsentInfoResponse, isCimdClientId } from '@logto/schemas';

import { isDevFeaturesEnabled } from '@/constants/env';

import api from './api';

export const consent = async (organizationIds?: string[]) => {
  type Response = {
    redirectTo: string;
  };

  return api
    .post('/api/interaction/consent', {
      json: { organizationIds },
    })
    .json<Response>();
};

export const getConsentInfo = async () => {
  const consentInfo = await api.get('/api/interaction/consent').json<ConsentInfoResponse>();

  // Organization roster gateway integration.
  if (
    !isDevFeaturesEnabled ||
    isCimdClientId(consentInfo.application.id) ||
    consentInfo.organizations === undefined
  ) {
    return consentInfo;
  }

  const { organizationIds } = await api
    .get('/consent/organizations', {
      headers: {
        'Logto-App-Id': consentInfo.application.id,
      },
    })
    .json<{ organizationIds: string[] }>();

  return {
    ...consentInfo,
    organizations: consentInfo.organizations.filter(({ id }) => organizationIds.includes(id)),
  };
};
